import * as React from 'react';

import { PropertyGallery } from '@shared-ui/lodging-property-details';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkLayoutPosition } from 'uitk-react-layout-position';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

export const GalleryWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => {
  const { getGalleryPlaceholderData } = usePropertyListing();

  return (
    <UitkLayoutPosition type="relative" position={{ zindex: 'layer1' }}>
      <PropertyGallery inputs={inputs} placeholderData={getGalleryPlaceholderData?.()} />
    </UitkLayoutPosition>
  );
};

export const SharedUiGalleryWrapper = withSharedUiPropertyDetails(GalleryWrapper);
SharedUiGalleryWrapper.displayName = 'SharedUiGalleryWrapper';
